<template>
  <page-view id="patients-index-view">
    <loader
      v-if="isLoading"
      style="height: 100vh;"/>
    <template v-else>
      <row>
        <sixteen-wide-column>
          <h1>{{ $t('patients.header') }}</h1>
          <form class="ui form">
            <new-item-button :item-type="'patient'"/>

            <search-bar
              :placeholder="$t('patientsSearch.placeholder')"
              @input="searchCriteria = $event"
              @run-search="search"
              @refresh-items="searchCriteria = ''; search()"/>
          </form>

          <search-summary
            type="patient"
            :items="patients"
            :query="query"/>

          <patients-table :patients="patients.result"/>

          <pagination
            v-if="patients.result.length > 0"
            :items="patients"
            @new-page-selected="paginationLink($event)"/>
        </sixteen-wide-column>
      </row>
    </template>
  </page-view>
</template>

<script>
import PatientsTable from '../components/patients/PatientsTable'
import Pagination from '../components/Pagination'
import SearchSummary from '../components/SearchSummary'
import SixteenWideColumn from '../components/utility/SixteenWideColumn'
import Row from '../components/utility/Row'
import { APIError } from '../helpers'
import SearchBar from '../components/SearchBar'
import NewItemButton from '../components/NewItemButton'

export default {
  name: 'Patients',
  components: {
    NewItemButton,
    SearchBar,
    Row,
    SixteenWideColumn,
    SearchSummary,
    Pagination,
    PatientsTable
  },
  data () {
    return {
      currentDate: new Date().getTime(),
      isLoading: true,
      query: {
        limit: 20,
        search: ''
      },
      searchCriteria: '',
      patients: null
    }
  },
  mounted () {
    this.query = Object.assign({}, this.query, this.$route.query)

    this.getPatients()
  },
  methods: {
    search () {
      this.query.search = this.searchCriteria
      this.getPatients()
    },
    paginationLink (index) {
      this.query.startIndex = index * this.query.limit
      this.getPatients(true)
    },
    getPatients (selectedPage = null) {
      this.isLoading = true
      let query = { ...this.query }

      return new Promise(
        (resolve, reject) => {
          let requestUrl = `${process.env.VUE_APP_PROGRAM_URL}/programUsers?sortKey=lastModifiedTime&sortAsc=false`

          // NOTE: Uncomment this code when `search` query parameter also searches for `externalId`
          // if (query) {
          //   requestUrl += query.hasOwnProperty('limit') ? `&limit=${query.limit}` : `&limit=100`
          //
          //   if (query.hasOwnProperty('search') && query.search !== '') { query.startIndex = 0 }
          //
          //   for (let key in query) {
          //     if (key !== 'limit' && query[key] !== '') {
          //       requestUrl += `&${key}=${query[key]}`
          //     }
          //   }
          // }

          // NOTE: START—Remove this block when `search` query parameter also searches for `externalId`
          let isSearchingByExternalId = query.hasOwnProperty('search') && this.hasDigitsOnly(query.search)

          if (query) {
            if (query.hasOwnProperty('search') && query.search !== '') {
              // NOTE: Reset `startIndex` to `0` if search term exists
              if (!selectedPage) { query.startIndex = 0 }

              // NOTE: Set first query parameter with `?` prefix
              if (isSearchingByExternalId) {
                requestUrl += `&limit=1000`
              } else {
                requestUrl += query.hasOwnProperty('limit') ? `&limit=${query.limit}` : `&limit=100`
              }

              for (let key in query) {
                if (key !== 'limit' && query[key] !== '') {
                  if (key !== 'search' || (key === 'search' && !isSearchingByExternalId)) {
                    requestUrl += `&${key}=${query[key]}`
                  }
                }
              }
            } else {
              requestUrl += query.hasOwnProperty('limit') ? `&limit=${query.limit}` : `&limit=100`

              for (let key in query) {
                if (key !== 'limit' && query[key] !== '') {
                  requestUrl += `&${key}=${query[key]}`
                }
              }
            }
          }
          // NOTE: END—Remove this block when `search` query parameter also searches for `externalId`

          this.$axios.get(
            requestUrl,
            this.requestConfig
          ).then(
            response => {
              this.searchCriteria = ''

              let paginatedResult = response.data.result
              let { result, ...others } = paginatedResult
              let filteredResult = result.filter(patient => !!patient.data)

              this.patients = { ...others, result: filteredResult }

              // NOTE: START—Remove this block when `search` query parameter also searches for `externalId`
              if (isSearchingByExternalId) {
                filteredResult = this.searchByExternalId(filteredResult)
                query.startIndex = 0

                let limit = query.limit
                let total = filteredResult.length
                let startIndex = query.startIndex

                let manuallyPaginatedItems = {
                  result: filteredResult.slice(startIndex, startIndex + limit),
                  startIndex,
                  total,
                  limit
                }

                this.patients = manuallyPaginatedItems
              }
              // NOTE: END—Remove this block when `search` query parameter also searches for `externalId`

              this.isLoading = false
              resolve()
            },
            ({ response }) => {
              reject(new APIError('Error fetching patients table', response))
            }
          )
        }
      ).catch(
        error => {
          this.$rollbar.error(error.message, error.response)
        }
      )
    },
    // NOTE: START—Remove this method when `search` query parameter also searches for `externalId`
    searchByExternalId: function (items) {
      let queryTerm = this.query.search.toString().toLowerCase()
      let result = items.filter(item => !!item.externalId && item.externalId.toString().toLowerCase().includes(queryTerm))

      return result
    }
  }
}
</script>

<style scoped>
</style>
